import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { DialogTitle } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';

export interface ICreateBudgetModalOptions {
    isOpen: boolean;
    populatedBudgetCallback(): void;
    emptyBudgetCallback(): void;
    onClose(): void;
}

export const CreateBudgetModal = ({
    isOpen,
    populatedBudgetCallback,
    emptyBudgetCallback,
    onClose,
}: ICreateBudgetModalOptions): React.ReactElement => {
    return (
        <div>
            <Dialog
                open={isOpen}
                onClose={onClose}
                aria-labelledby='form-dialog-title'
                aria-describedby='alert-dialog-description'
            >
                <DialogTitle>
                    <FontAwesomeIcon
                        icon={faClose}
                        size={'1x'}
                        onClick={onClose}
                        style={{
                            cursor: 'pointer',
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    />
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id='alert-dialog-description'>
                        Create an empty budget or populate with commonly used fields?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-evenly',
                            width: '100%',
                        }}
                    >
                        <button
                            type='button'
                            className='button primary'
                            onClick={emptyBudgetCallback}
                        >
                            Empty Template
                        </button>
                        <button
                            type='button'
                            className='button primary'
                            onClick={populatedBudgetCallback}
                        >
                            Populated Template
                        </button>
                    </div>
                </DialogActions>
            </Dialog>
        </div>
    );
};
